/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{BufferObject as t}from"./BufferObject.js";class r extends t{constructor(t,r,s,e=35044){super(t,34962,e,s),this.layout=r}}export{r as VertexBuffer};
